module.exports = __webpack_public_path__ + "static/media/Francis Karuhanga.83fcfd65.jpg";